module.exports = __webpack_public_path__ + "img/ywcgq0.9f0c1d63.png";